module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATklEQVQImTWKsQ2AQAzEjECUrEPJEnQ/AROxALT8FIxEbRQpiZSczg7qqj7qrEaPHdVL3Qo0tedTySPcECenATvwAS9wBpzKAnfmUhLgB2v7Ow6/wZDwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jt.png
// module id = DmtO
// module chunks = 2